import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Drawer } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';

export interface SidePanelProps extends PropsWithChildren {
    showCloseButton?: boolean;
    side: 'left' | 'right';
    width?: number;
    zIndex?: number;
    hide?: boolean;
    onClose: () => void;
    className?: string;
    classesInner?: {
        root?: string;
        paper?: string;
    };
    classesBackdrop?: {
        classes?: {
            root?: string;
        };
    };
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            'zIndex': 999,
            '& .MuiDrawer-paperAnchorRight': {
                width: '100%',
                [theme.breakpoints.up('md')]: {
                    width: (props: SidePanelProps) => `${props.width ?? 590}px !important`
                }
            }
        },
        closeButtonContainer: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            [theme.breakpoints.down(960)]: {
                display: 'none'
            }
        },
        closeButton: (props: SidePanelProps) => ({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#000000',
            borderRadius: '50%',
            top: 24,
            right: props.side === 'right' ? (props.width ?? 590) + 30 : undefined,
            left: props.side === 'left' ? (props.width ?? 590) + 30 : undefined,
            position: 'fixed',
            cursor: 'pointer',
            height: 46,
            width: 46
        }),
        closeIcon: {
            color: '#FFFFFF',
            height: 20,
            width: 20
        }
    })
);

export const SidePanel: FunctionComponent<SidePanelProps> = props => {
    const classes = useStyles(props);

    return (
        <Drawer
            onClose={props.onClose}
            open={!(props.hide ?? false)}
            anchor={props.side}
            className={clsx(classes.container, props.className)}
            classes={{
                ...props.classesInner,
                paper: props.classesInner?.paper
            }}
            BackdropProps={{
                classes: {
                    ...props.classesBackdrop?.classes
                }
            }}
            style={{
                zIndex: props.zIndex // custom zIndex
            }}
        >
            {props.showCloseButton && (
                <Box className={classes.closeButtonContainer}>
                    <Box
                        className={classes.closeButton}
                        onClick={props.onClose}
                    >
                        <FontAwesomeIcon
                            icon={faXmark}
                            className={classes.closeIcon}
                        />
                    </Box>
                </Box>
            )}
            {props.children}
        </Drawer>
    );
};

export default SidePanel;
